/* The CookBook email gate (recipe side). Spec: web/sections/cookbook/spec.md, "Gate v2".
   The inline check in snippets/bp-cookbook-gate.liquid locks the page before it paints. This file
   lifts the lock for visitors Klaviyo already knows, and on Send posts the email to the
   lead-magnet endpoint, which subscribes them; on ok the veil lifts and the unlock is kept. */
(function () {
  var KEY = 'bp_cookbook_unlocked';
  var html = document.documentElement;
  var gate = document.querySelector('[data-bp-gate]');
  if (!gate || !html.classList.contains('bp-gate-locked')) return;

  var form = gate.querySelector('form');
  var input = gate.querySelector('.bp-cookbook-gate__input');
  var error = gate.querySelector('.bp-cookbook-gate__error');
  var pot = gate.querySelector('.bp-cookbook-gate__pot input');
  var consent = gate.querySelector('.bp-cookbook-gate__fine');
  var label = gate.querySelector('.button__label');
  var btn = gate.querySelector('button[type="submit"]');
  var sendLabel = label.textContent;

  function unlock() {
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
    html.classList.remove('bp-gate-locked');
  }
  function setLabel(t) { label.textContent = t; label.setAttribute('data-label', t); }
  function stored(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }

  // Already on our list: Klaviyo recognises them (e.g. they came from one of our emails).
  if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
    Promise.resolve(window.klaviyo.isIdentified()).then(function (known) { if (known) unlock(); }).catch(function () {});
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    error.hidden = true;
    if (!input.checkValidity() || !input.value) { error.hidden = false; input.focus(); return; }
    btn.disabled = true;
    setLabel('…');
    fetch(gate.getAttribute('data-endpoint'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: input.value.trim(),
        lm: gate.getAttribute('data-magnet'),
        locale: gate.getAttribute('data-locale') || 'en',
        // the exact sentence they read, stored as the consent record
        consent_text: consent ? consent.textContent.trim() : '',
        page_url: location.href,
        company: pot ? pot.value : '',
        first_touch: stored('bp_first') || {}
      })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (out) {
        if (!out || !out.ok) return Promise.reject('no');
        unlock();
      })
      .catch(function () {
        error.hidden = false;
        btn.disabled = false;
        setLabel(sendLabel);
      });
  });
})();
